import axios from 'axios';

const sixYardAxios = axios.create({
  baseURL: "https://api.6yard.com/api/v1",
});

  sixYardAxios.interceptors.request.use(async (req) => {
    let language = localStorage.getItem('language') === '0' ? 'ar' : 'en';    
    req.headers['Accept-Language'] = language;

    let token = localStorage.getItem('token');
    req.headers.Authorization = `Bearer ${token}`;

    return req;
  });
export { sixYardAxios };